import clariaBlackLogo from '../assets/svgs/claria-black-logo.svg';
import eviaBlackLogo from '../assets/svgs/evia-black-logo.svg';
import finitoBlackLogo from '../assets/svgs/finito-black-logo.svg';
import group from '../assets/svgs/group.svg';
import hyperlink from '../assets/svgs/hyperlink.svg';
import nervaLogoBlack from '../assets/svgs/nervaAppIconBlack.svg';
import phone from '../assets/svgs/phone.svg';
import refer from '../assets/svgs/refer.svg';
import user from '../assets/svgs/user.svg';
import { LinkedPatientsScreen } from '../screens/App/LinkedPatients/LinkedPatientsScreen';
import { MyAccount } from '../screens/App/MyAccount/MyAccountScreen';
import { NervaProgram } from '../screens/App/Programs/NervaProgram';
import { Programs } from '../screens/App/Programs/Programs';
import { ReferralOnePagerScreen } from '../screens/App/ReferralOnePager/ReferralOnePagerScreen';
import { EmailVerificationScreen } from '../screens/Auth/EmailVerificationScreen';
import { InvalidReferralLinkScreen } from '../screens/Auth/InvalidReferralLinkScreen';
import { PatientConsentScreen } from '../screens/Auth/PatientConsentScreen';
import { PatientThankYouScreen } from '../screens/Auth/PatientThankYouScreen';
import { SignInOrRegisterScreen } from '../screens/Auth/SignInOrRegisterScreen';
import { RouteInfoType } from './types';

const linkedPatientsRoutes: RouteInfoType = {
  id: 'linked-patients',
  name: 'Linked Nerva Patients',
  icon: hyperlink,
  path: '/linked-patients',
  component: LinkedPatientsScreen,
  children: null,
  showInMenu: true,
};

const nervaReferralRoutes: RouteInfoType = {
  id: 'nerva-referral',
  name: 'Nerva Referral',
  icon: refer,
  path: 'https://nerva.mindsethealth.com/refer?utm_source=connect',
  component: null,
  children: null,
  showInMenu: true,
  externalLink: true,
};

const programsRoutes: RouteInfoType = {
  id: 'programs',
  name: 'Programs',
  icon: phone,
  path: '/programs',
  component: Programs,
  showInMenu: true,
  children: [
    {
      id: 'nerva',
      name: 'nerva',
      icon: nervaLogoBlack,
      path: '/programs/nerva',
      component: NervaProgram,
      children: null,
      showInMenu: false,
    },
    {
      id: 'evia',
      name: 'evia',
      icon: eviaBlackLogo,
      path: 'https://www.mindsethealth.com/evia-for-clinicians',
      component: NervaProgram,
      children: null,
      showInMenu: false,
    },
    {
      id: 'finito',
      name: 'finito',
      icon: finitoBlackLogo,
      path: '/programs/nerva',
      component: NervaProgram,
      children: null,
      showInMenu: false,
    },
    {
      id: 'claria',
      name: 'claria',
      icon: clariaBlackLogo,
      path: '/programs/nerva',
      component: NervaProgram,
      children: null,
      showInMenu: false,
    },
  ],
};

const myAccountRoutes: RouteInfoType = {
  id: 'my-account',
  name: 'My Account',
  icon: user,
  path: '/my-account',
  component: MyAccount,
  children: null,
  showInMenu: true,
};

const referralOnePagerRoutes: RouteInfoType = {
  id: 'referral-one-pager',
  name: 'Nerva One Pager',
  icon: group,
  path: '/referral-one-pager',
  component: ReferralOnePagerScreen,
  children: null,
  showInMenu: false,
};

const authRoutes: RouteInfoType = {
  id: 'auth',
  name: 'Auth',
  path: '/auth',
  component: null,
  showInMenu: true,
  children: [
    {
      id: 'auth-sign-in-or-register',
      path: '/auth/sign-in-or-register',
      name: 'Sign In',
      component: SignInOrRegisterScreen,
      children: null,
      showInMenu: true,
    },
    {
      id: 'auth-email-verification',
      path: '/auth/email-verification',
      name: 'Verify Email',
      component: EmailVerificationScreen,
      children: null,
      showInMenu: true,
    },
    {
      id: 'auth-patient-uid',
      path: '/patient/:uid',
      name: 'Link Hcp To Patient',
      component: SignInOrRegisterScreen,
      children: null,
      showInMenu: true,
    },
    {
      id: 'auth-patient-consent',
      path: '/users/patient/consent',
      name: 'Patient Consent',
      component: PatientConsentScreen,
      showInMenu: true,
    },
    {
      id: 'auth-patient-thank-you',
      path: '/users/patient/thank-you',
      name: 'Patient Thank You',
      component: PatientThankYouScreen,
      children: null,
      showInMenu: true,
    },
    {
      id: 'auth-invalid-referral-link',
      path: '/users/patient/invalid-link',
      name: 'Invalid referral link',
      component: InvalidReferralLinkScreen,
      children: null,
      showInMenu: true,
    },
  ],
};

export const appLayoutRoutes = [
  programsRoutes,
  linkedPatientsRoutes,
  referralOnePagerRoutes,
  myAccountRoutes,
  nervaReferralRoutes,
];
export const authLayoutRoutes = [authRoutes];
